import { app } from '../../../../app';
import { Controller } from './email-verification.controller';

app.component('emailVerification', {
    controller: Controller,
    templateUrl: require('./email-verification.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/public/verification/email/email-verification.component.js